import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  CardFooter,
  Label,
  FormGroup,
  Input,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import React, { useMemo, useState, useEffect, useContext } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
LoadingOverlay.propTypes = undefined;
import { ToastContainer, toast } from "react-toastify";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Switch from "react-bootstrap-switch";
import { MainContext } from "context/MainContext.js";

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";

function SubscriberList() {
  const history = useHistory();
  const location = useLocation();
  const [params, setParams] = useState(location.state?.value ?? "");

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.subscribers.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  const [deleteEndpointState, setDeleteEndpointState] = useState(false);
  const [deleteSubscriberId, setDeleteSubscriberId] = useState(null);
  const [forceRefreshCount, setForceRefreshCount] = useState(0);
  const [showLoading, setShowLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const privileges = useContext(MainContext);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const openDevicePortal = (serialNumber) => {
    fetch("/api/v1/device/url", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        serialNumber: serialNumber,
        virtuosoPort: window.location.port,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        window.open(actualData.data.url, "_blank", "noreferrer");
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const redirectToDeviceDetails = (serialNumber) => {
    const location = {
      pathname: "/admin/devices/details",
      state: {
        value: serialNumber,
      },
    };
    history.push(location);
  };

  const deleteEndpointSwitchChange = (e) => {
    setDeleteEndpointState(() => e.state.value);
  };

  const inputAlert = (id) => {
    setDeleteSubscriberId(id);
    setAlert("Alert");
  };

  const hideAlert = () => {
    setAlert(null);
  };

  function handleDeviceCheckbox(e) {
    const { value, checked } = e.target;

    columns = null;

    if (checked) {
      setSelectedDevices((selectedDevices) => [...selectedDevices, value]);
    } else {
      setSelectedDevices((device) => device.filter((v) => v !== value));
    }
  }

  const handleSelectAll = (e, data) => {
    const { checked } = e.target;
    if (checked) {
      setSelectAll(true);
      setSelectedDevices([]);
      setSelectedDevices(data.map((device) => device.id));
    } else {
      setSelectAll(false);
      setSelectedDevices([]);
    }
  };

  const removeSubscriber = () => {
    setShowLoading(true);
    hideAlert();

    fetch("/api/v1/subscriber/delete", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: [deleteSubscriberId],
        deleteEndpoint: deleteEndpointState,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        if (actualData.error_code) {
          toast.error("A problem occured while removing the subscriber", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setForceRefreshCount((forceRefreshCount) => forceRefreshCount + 1);
          toast.success("Subscriber removed successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  var columns = [
    {
      accessor: "selector",
      sortable: false,
      filterable: false,
      disableExport: true,
      flex: "0 1 5%",
      Header: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (
          userLevel >= 15 &&
          Utilities.validateLicense(
            sessionStorage.getItem("licenseTypes"),
            Utilities.LICENSE_PRO,
          )
        ) {
          return (
            <div style={{ paddingLeft: "0px", paddingBottom: "8px" }}>
              <FormGroup check>
                <Label check>
                  <>
                    <Input
                      type="checkbox"
                      name="endpointAll"
                      onChange={(event) => handleSelectAll(event, props.data)}
                      checked={selectAll}
                    />
                    <span className="form-check-sign" />
                  </>
                </Label>
              </FormGroup>
            </div>
          );
        } else {
          return (
            <div style={{ paddingLeft: "8px", paddingBottom: "8px" }}></div>
          );
        }
      },
      Cell: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (
          userLevel >= 15 &&
          Utilities.validateLicense(
            sessionStorage.getItem("licenseTypes"),
            Utilities.LICENSE_PRO,
          )
        ) {
          return (
            <div style={{ paddingLeft: "8px", paddingBottom: "8px" }}>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    value={props.row.original.id}
                    checked={selectedDevices.includes(props.row.original.id)}
                    onChange={handleDeviceCheckbox}
                  />
                  <span className="form-check-sign" />
                </Label>
              </FormGroup>
            </div>
          );
        } else {
          <div style={{ paddingLeft: "8px", paddingBottom: "8px" }}></div>;
        }
      },
    },
    {
      Header: "id",
      accessor: "id",
      sortBy: "id",
      flex: "1 1 0",
      show: false,
      filterable: false,
      disableExport: true,
    },
    {
      Header: "Name",
      accessor: "name",
      sortBy: "nameSort",
      flex: "1 1 0",
      Cell: (props) => {
        return (
          <a
            onClick={() => redirectToEndpointDetails(props.row.original.id)}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {props.value}
          </a>
        );
      },
    },
    {
      Header: "Description",
      accessor: "description",
      sortBy: "description",
      flex: "1 1 0",
    },
    {
      Header: "Endpoint",
      accessor: "macAddress",
      sortBy: "endpointMacAddress",
      flex: "1 1 0",
      Cell: (props) => {
        return <>{props.value == "00:00:00:00:00:00" ? "" : props.value}</>;
      },
    },
    {
      Header: "Bandwidth",
      accessor: "bandwidth",
      sortBy: "bwProfileName",
      Cell: (props) => {
        return <>{props.value == "" ? "Unthrottled" : props.value}</>;
      },
      flex: "1 1 0",
    },
    {
      Header: "VLAN Id Port #1",
      accessor: "port1",
      sortBy: "port1VlanId",
      flex: "1 1 0",
    },
    {
      Header: "VLAN Id Port #2",
      accessor: "port2",
      sortBy: "port2VlanId",
      flex: "1 1 0",
    },
    {
      Header: "System Name",
      accessor: "deviceName",
      sortBy: "device.name",
      Cell: (props) => {
        return (
          <a
            onClick={() =>
              redirectToDeviceDetails(props.row.original.deviceSerialNumber)
            }
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {props.value}
          </a>
        );
      },
    },
    {
      Header: "GAM IP Address",
      accessor: "deviceIpAddress",
      sortBy: "device.ipAddress",
      flex: "1 1 0",
    },
    {
      Header: "Groups",
      accessor: "groups",
      sortBy: "g.name",
      show: false,
      flex: "1 1 0",
    },
    {
      Header: "Serial Number",
      accessor: "deviceSerialNumber",
      sortBy: "device.serialNumber",
      flex: "1 1 0",
      show: false,
      filterable: false,
      disableExport: true,
    },
    {
      Header: "Last Seen",
      accessor: "lastModifiedDate",
      sortBy: "lastModifiedDate",
      flex: "1 1 0",
      show: false,
      filterable: false,
      disableExport: true,
    },
    {
      Header: "",
      accessor: "actions",
      Cell: (props) => {
        return (
          <UncontrolledDropdown direction="down">
            <DropdownToggle
              caret
              color="info"
              style={{
                padding: "6px 14px 6px 14px",
                margin: "0px",
              }}
            >
              Actions
            </DropdownToggle>
            <DropdownMenu container={"body"}>
              {Utilities.hasAccess(privileges["devices.subscribers.edit"]) &&
              Utilities.validateLicense(
                sessionStorage.getItem("licenseTypes"),
                Utilities.LICENSE_PRO,
              ) &&
              props.row.original.deviceLicenseActive ? (
                <DropdownItem
                  onClick={() =>
                    redirectToSubscriberEditPage(props.row.original.id)
                  }
                >
                  Edit Subscriber
                </DropdownItem>
              ) : (
                ""
              )}
              {Utilities.hasAccess(privileges["devices.subscribers.delete"]) &&
              Utilities.validateLicense(
                sessionStorage.getItem("licenseTypes"),
                Utilities.LICENSE_PRO,
              ) ? (
                <DropdownItem onClick={() => inputAlert(props.row.original.id)}>
                  Remove Subscriber
                </DropdownItem>
              ) : (
                ""
              )}

              <DropdownItem
                onClick={() =>
                  redirectToEndpointDetails(
                    props.row.original.id,
                    props.row.original.endpointId,
                  )
                }
              >
                View Details
              </DropdownItem>

              <DropdownItem
                onClick={() =>
                  redirectToDeviceDetails(props.row.original.deviceSerialNumber)
                }
              >
                View GAM Details
              </DropdownItem>
              {sessionStorage
                .getItem("permissions")
                .includes("GAM_PORTAL_ACCESS") ? (
                <>
                  <DropdownItem divider />
                  <DropdownItem
                    onClick={() =>
                      openDevicePortal(props.row.original.deviceSerialNumber)
                    }
                  >
                    Open GAM Portal
                  </DropdownItem>
                </>
              ) : (
                ""
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
      flex: "1 1 0",
      padding: "0px",
      sortable: false,
      filterable: false,
    },
  ];

  const redirectToEndpointDetails = (subscriberId, endpointId) => {
    const location = {
      pathname: "/admin/endpoints/details",
      state: {
        endpointId: endpointId,
        subscriberId: subscriberId,
      },
    };
    history.push(location);
  };

  const redirectToSubscriberEditPage = (subscriberId) => {
    const location = {
      pathname: "/admin/subscribers/edit",
      state: {
        value: subscriberId,
      },
    };
    history.push(location);
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert ? (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want to delete this subscriber ?"
            onConfirm={() => {
              removeSubscriber();
            }}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          >
            <Switch
              name="deleteEndpoint"
              offColor="success"
              offText={<i className="nc-icon nc-simple-remove" />}
              onColor="success"
              onText={<i className="nc-icon nc-check-2" />}
              onChange={deleteEndpointSwitchChange}
              value={deleteEndpointState}
            />{" "}
            Delete Associated Endpoint
          </ReactBSAlert>
        ) : (
          ""
        )}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  {params && params.includes("serialNumber") ? (
                    <BreadcrumbItem>
                      <NavLink
                        to={{
                          pathname: "/admin/devices/list",
                        }}
                      >
                        GAM
                      </NavLink>
                      <i>&lt;{params.split("||")[1]}&gt;</i>
                    </BreadcrumbItem>
                  ) : (
                    ""
                  )}
                  <BreadcrumbItem>Subscribers</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <ReactTable
                  query="/api/v1/subscriber/list"
                  columns={columns}
                  param={params}
                  title="Subscribers"
                  forceRefresh={forceRefreshCount}
                  className="-striped -highlight primary-pagination"
                  submethodParam={selectedDevices}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default SubscriberList;
